import { IonButton, IonIcon, ModalController } from '@ionic/angular/standalone';

import { Component, input, OnInit, inject } from '@angular/core';

import { Capacitor } from '@capacitor/core';
import { PageHelperService } from 'src/app/services/page-helper/page-helper.service';
import { AutoIdCardService } from 'src/app/pages/auto/auto-id-card-list/auto-id-card.service';
import { DocumentType, MimeType } from '../../../models/account';
import { finalize, Subject, takeUntil } from 'rxjs';
import { FileManagerService } from 'src/app/services/file-manager/file-manager.service';
import { eGain } from 'src/app/util/eGain';

@Component({
  selector: 'app-file-display-error-modal',
  templateUrl: './file-display-error-modal.component.html',
  styleUrls: ['./file-display-error-modal.component.scss'],
  imports: [IonButton, IonIcon],
})
export class FileDisplayErrorModalComponent implements OnInit {
  private modalController = inject(ModalController);
  private egain = inject(eGain);

  readonly autoId = input<boolean>(false);

  ngOnInit() {}

  cancel() {
    this.modalController.dismiss({ tryAgain: false });
  }
  openChat() {
    this.egain.clickToChat();
  }
  tryAgain() {
    this.modalController.dismiss({ tryAgain: true });
  }
}
